<div class="container">
    <div class="add-library-container" *ngIf="isOpenAddLibraryContainer">
        <div class="select-button justify-end" (click)="clearCreateComponent()">
            <span class="pointer">{{ 'editor.library.settings.clear-setting' | translate }}</span>
        </div>
        <div class="add-library">
            <div class="sub-title">
                {{ 'editor.library.settings.add-library' | translate }}
            </div>
            <app-channel-select-input
                name="library"
                label="editor.library.select-library.label"
                [dark]="true"
                [itemList]="libraryNameList"
                [value]="selectedLibrary?.name"
                (inputChange)="selectLibrary($event)"
                [height]="400">
            </app-channel-select-input>
            <app-channel-select-input
                name="category"
                label="editor.library.select-category.label"
                [dark]="true"
                [itemList]="libraryCategoryNameList"
                [value]="selectedCategory?.name"
                (inputChange)="selectCategory($event)"
                [height]="400">
            </app-channel-select-input>
            <app-editor-input-text
                name="component"
                label="editor.library.component-name.label"
                [value]="componentName"
                type="text"
                (onInputChange)="changeName($event)"
                [focusEffect]="true">
            </app-editor-input-text>
            <app-button
                [text]="'editor.library.add-library.button'"
                [disable]="isCreateButtonDisabled()"
                (onClick)="createComponent()"
                [customFontSize]="'12px'"></app-button>
            <div class="select-button-container" (click)="openNewLibraryDialog()">
                {{ 'editor.library.add-category.button' | translate }}
            </div>
        </div>
    </div>
    <div class="component-list" *ngIf="selectedElementComponentList?.length && !isLoading">
        <div class="sub-title library-option-title">
            {{ 'editor.library.library-option.title' | translate }}
        </div>
        <div class="title">
            {{ 'editor.library.library-option.sub-title' | translate }}
        </div>
        <div class="component" *ngFor="let component of selectedElementComponentList; index as i">
            <div class="item-box">
                <div class="title">{{ component.name }}</div>
                <div class="sub-title">{{ componentCategoryNameList[i] }}</div>
                <div class="select-button none-padding">
                    <span class="pointer">{{ 'dlg.edit' | translate }}</span>
                </div>
            </div>
            <div class="sub-title remove-text" (click)="deleteComponent(component)">
                <span class="pointer">{{ 'editor.library.remove' | translate }}</span>
            </div>
        </div>
    </div>
    <div class="loading-container" *ngIf="isLoading">
        <app-loading-spinner
            class="spinner-component"
            [class.edit]="editMode"
            [custom]="true"
            size="120"
            strokeWidth="5"></app-loading-spinner>
    </div>
</div>

<app-confirmation-window
    #deleteDialog
    [mainLabel]="deleteMainMessage"
    subLabel="editor.library.delete.component.sub-message"
    [goBackLabel]="'dlg.cancel'"
    [saveLabel]="'dlg.confirm'"></app-confirmation-window>
